// 子账号登录的general/sso SDK   https://npm.corp.kuaishou.com/-/web/detail/@ks/general-sso
import {
    init,
    requestSmsCode,
    smsCodeLogin,
    chooseUser,
    logout,
} from '@ks/general-sso';
import { inBrowser } from '@utils';

if (inBrowser) {
    init({
        env:
            process.env.net_env === 'staging'
                ? 'staging'
                : 'production',
        sid: 'locallife.merchant.api',
        appName: 'locallife',
        baseUrl:
            process.env.net_env === 'staging'
                ? 'https://locallifeid.staging.kuaishou.com'
                :'https://id.kuaishou.com',
    });
}

export default {
    requestSmsCode,
    smsCodeLogin,
    chooseUser,
    logout,
};
